import { useState } from "react";
import { Header } from "./Header";
import { Hero } from "./Hero";
import { WhatYouGet } from "./WhatYouGet";
import { Shape } from "./Shape";
import { Artifacts } from "./Artifacts";
import { Pricing } from "./Pricing";
import { Faq } from "./Faq";
import { Footer } from "./Footer";
import { UpgradeModal } from "../users/UpgradeModal";
import "./landing.css";

interface Props {
  onStartFree: () => void;
  onSignIn: () => void;
  /** Pro path: go straight to signup (skips the free data-notice consent). */
  onGoPro: () => void;
}

export function LandingScreen({ onStartFree, onSignIn, onGoPro }: Props) {
  const [showGoPro, setShowGoPro] = useState(false);
  const openGoPro = () => setShowGoPro(true);
  return (
    <div className="lp">
      <a className="lp-skip" href="#main">Skip to content</a>
      <Header onSignIn={onSignIn} />
      <main>
        <Hero onStartFree={onStartFree} onGoPro={openGoPro} />
        <WhatYouGet />
        <Shape />
        <Artifacts />
        <Pricing onStartFree={onStartFree} onGoPro={openGoPro} />
        <Faq />
      </main>
      <Footer />
      <UpgradeModal
        open={showGoPro}
        feature="individual-plan"
        onClose={() => setShowGoPro(false)}
        onSignUp={() => {
          setShowGoPro(false);
          onGoPro();
        }}
      />
    </div>
  );
}
